import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { FileText, Image as ImageIcon, Box } from "lucide-react";
import { IMAGE_EXT, MODEL_EXT } from "@/lib/files";

// Vorschaubild mit Anmeldung (Thumbnail-Endpunkt erwartet den Bearer-Token) – sonst Datei-Symbol
export function FileThumb({ att, className = "w-16 h-16" }) {
  const [url, setUrl] = useState("");
  useEffect(() => {
    if (!att.has_thumb) return undefined;
    let alive = true, u = "";
    api.get(`/attachments/${att.id}/thumb`, { responseType: "blob" })
      .then((r) => { if (alive) { u = URL.createObjectURL(r.data); setUrl(u); } })
      .catch(() => {});
    return () => { alive = false; if (u) URL.revokeObjectURL(u); };
  }, [att.id, att.has_thumb]);
  const Icon = IMAGE_EXT.has(att.ext) ? ImageIcon : MODEL_EXT.has(att.ext) ? Box : FileText;
  return (
    <div className={`${className} flex-shrink-0 bg-slate-100 border border-slate-200 rounded flex items-center justify-center overflow-hidden`} data-testid={`file-thumb-${att.id}`}>
      {url ? <img src={url} alt={att.original_name} className="w-full h-full object-cover" /> : <Icon className="w-7 h-7 text-slate-400" />}
    </div>
  );
}
